import { HttpClient } from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { Userlogin } from "../models/userlogin";
import { environment } from "../../environments/environment";
import { Employees } from "../models/employees";
import { Role } from "../models/role";
import { Department } from "../models/department";
import { CompanyBrnch } from "../models/companybrnch";
import { Company } from '../pages/masters/company/company';


@Injectable(
  {
    providedIn: 'root'
  }
)
export class UserloginService
{
  constructor(private http: HttpClient) { }

  private baseUrl = `${environment.apiUrl}/tms/userlogin`;

  createUserlogin (userlogin: Object): Observable<Object> {
    return this.http.post(`${this.baseUrl}` + `/create`, userlogin, {observe: 'response'});
  }

 
  updateUserlogin (userlogin: Object): Observable<Object> {
    return this.http.put(`${this.baseUrl}` + `/update`, userlogin, {observe: 'response'});
  }
  getBranchByCompanyCode(companyCode){
    return this.http.get<CompanyBrnch[]>(`${environment.apiUrl}/tms/companybranch/findCompany/${companyCode}`);
  }
  getEmployeeByCompanyCode(companyCode){
    return this.http.get<Employees[]>(`${environment.apiUrl}/tms/employee/findAll/${companyCode}`)
  }
  
  listDepartment(companyId) {
  return this.http.get<Department[]>(`${environment.apiUrl}/tms/department/findall/${companyId}`);
  }

  getLogedInUsers(companyId) {
    return this.http.get<Userlogin[]>(`${environment.apiUrl}/tms/userlogin/findlogedin/${companyId}`);
    }


  listRole(companyId)
  {
  return this.http.get<Role[]>(`${environment.apiUrl}/tms/role/findAll/${companyId}`) ;
  }
  getLoginByCompanyCode(companyCode){
    return this.http.get<Userlogin[]>(`${environment.apiUrl}/tms/userlogin/findAll/${companyCode}`);
  }
  allCompany(id: number): Observable<Object> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
  searchLogin(companyCode,branchId,empCode){
    return this.http.get(`${environment.apiUrl}/tms/userlogin/searchLogin/${companyCode}/${branchId}/${empCode}`);
  }

  userLogOut(loginId,id) {
    return this.http.get(`${environment.apiUrl}/tms/userlogin/logout/` + loginId+'/'+id ).pipe()
  }
  getCompanyLogo(companyId){
    return this.http.get(`${environment.apiUrl}/tms/company/companylogo/` + companyId)
  }

}